import {css} from '@yandex-delivery/blocks/theme/css'
import {spacing} from '@yandex-delivery/blocks/theme/theme'

export const skeleton = {
  input: css`
    block-size: ${spacing(6)};
    inline-size: ${spacing(66.75)};
  `,
  label: css`
    block-size: ${spacing(1.5)};
    inline-size: ${spacing(18)};
  `,
}

export const wrapper = {
  content: css`
    padding-inline-start: ${spacing(5)};
  `,
  label: css`
    gap: ${spacing(1)};
  `,
}
